import Validation from '../validation/validation';
import Notification from '../notification/notification';

export default new class subscriptionBlock {
  constructor() {
    this.subscriptionBlock = '.subscription-block';
    this.subscriptionBlockWrapper = '.subscription-block__wrapper';
    this.subscriptionBlockForm = '.subscription-block__form';
    this.subscriptionSuccessBlock = '.subscription-block__success';
    this.subscriptionBlockBtn = '.subscription-block__btn';
    this.subscriptionBlockInput = '.subscription-block__input';
    this.agreeCheckbox ='.agree-checkbox__subs';
    this.agreeLabel = '.agree-checkbox__label';

    this.init();
  }

  init() {
    document.querySelector('.form-item__error').style.display = 'none';
    if (!$(this.subscriptionBlock).length) {
      return;
    }

    document.querySelector(this.agreeCheckbox).checked = false;

    this.bindEvents();
  }

  bindEvents() {
    $(document).on('change', this.agreeCheckbox, () => {
      if (!document.querySelector(this.agreeCheckbox).checked) {
        document.querySelector(this.agreeLabel).classList.add('__error');
      } else {
        document.querySelector(this.agreeLabel).classList.remove('__error');
      }
    });

    $(document).on('click', this.subscriptionBlockBtn, (e) => {
      e.preventDefault();

      const $form = $(e.target).closest(this.subscriptionBlock);
      const $input = $form.find(this.subscriptionBlockInput);
      const $checkbox = $form.find(this.agreeCheckbox);

      if (!Validation.isFormValid($form)) {
        document.querySelector('.form-item__error').style.display = 'block';
        return;
      } else {
        document.querySelector('.form-item__error').style.display = 'none';
      }

      if (!document.querySelector(this.agreeCheckbox).checked) {
        document.querySelector(this.agreeLabel).classList.add('__error');
        return;
      } else {
        document.querySelector(this.agreeLabel).classList.remove('__error');
      }

      $.request('LVSubscriptions::onSubscribe', {
        data: { email: $input.val(), agree: $checkbox.is(':checked')},
        complete: () => {
          /* response success */
          $(this.subscriptionSuccessBlock).css('display', 'flex');
          document.querySelector('.form-item__error').style.display = 'none';
          document.querySelector(this.agreeLabel).classList.remove('__error');
          document.querySelector(this.agreeCheckbox).checked = false;
          document.querySelector(this.subscriptionBlockInput).value = '';
          $(this.subscriptionBlockForm).css('display', 'none');

        },
        error: () => {
          Notification.showError('Ошибка подписки');
        },
      });
    });
  }
}();
